export enum Currency {
	EURO = 'EUR'
}
